var map = {
	"./arrow-blue.svg": 9933,
	"./arrow-down.svg": 4746,
	"./arrow-open.svg": 4485,
	"./back.svg": 7911,
	"./calendar.svg": 874,
	"./check-color.svg": 5875,
	"./check.svg": 706,
	"./cross-arrow.svg": 2810,
	"./delete.svg": 2539,
	"./enlarge.svg": 9373,
	"./good-color.svg": 9878,
	"./good.svg": 6770,
	"./heart-color.svg": 8178,
	"./heart.svg": 3972,
	"./logo-test.svg": 5204,
	"./logo.svg": 3190,
	"./logout.svg": 2990,
	"./loop-circular.svg": 2703,
	"./message.svg": 5070,
	"./star-color.svg": 9912,
	"./star.svg": 3740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;